export const ADD_MEDIA_LIB_CONTENT_API = "host/create/content";
